import { ErrorMessage, Field } from "formik";
import { AddAccountStepProps } from "./StepModel";
import clsx from "clsx";
import { sendClientEmailVerificationCode } from "../AddAccountSlice";
import translations from "utils/translationUtility";

export const EmailAddressStep: React.FC<AddAccountStepProps> = ({ currentStep, formikProps }: AddAccountStepProps) => (
  <>
    <p className="col-lg-4 col-form-label required fw-bold fs-6">{translations.client} Email Address</p>
    <div className="col-lg-8">
      <div className="row">
        <div className="col-lg-6 fv-row">
          <Field
            aria-label="Client email address"
            type="email"
            className={clsx(
              "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
              { "is-invalid": formikProps.touched.emailAddress && formikProps.errors.emailAddress },
              {
                "is-valid": formikProps.touched.emailAddress && !formikProps.errors.emailAddress,
              }
            )}
            placeholder={`${translations.client} Email Address`}
            name="emailAddress"
            autoComplete="off"
            data-test-id="add-account-form__email-address-input"
          />
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <ErrorMessage name="emailAddress" key={currentStep.toString()} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export const EmailAddressSubmit = ({ values, thunkDispatch }) => {
  thunkDispatch(
    sendClientEmailVerificationCode({
      emailAddress: values.emailAddress,
      clientAccountNumber: values.clientAccountNumber,
    })
  );
};
